import { useRef, useState } from "react";

export interface UseHoverOptions {
  mouseEnterDelayMS?: number;
  mouseLeaveDelayMS?: number;
}

export type HoverProps = Pick<React.HTMLAttributes<HTMLElement>, "onMouseEnter" | "onMouseLeave">;

export default function useHover({ mouseEnterDelayMS = 0, mouseLeaveDelayMS = 0 }: UseHoverOptions = {}): [
  boolean,
  { onMouseEnter: () => void; onMouseLeave: () => void }
] {
  const [isHovering, setIsHovering] = useState(false);
  const isHoveringRef = useRef<boolean>(false);

  let mouseEnterTimer: NodeJS.Timeout | undefined;
  let mouseOutTimer: NodeJS.Timeout | undefined;

  const onMouseEnter = () => {
    if (mouseEnterDelayMS > 0) {
      clearTimeout(mouseOutTimer);
      mouseEnterTimer = setTimeout(() => {
        setIsHovering(true);
        isHoveringRef.current = true;
      }, mouseEnterDelayMS);
    } else {
      setIsHovering(true);
    }
  };

  const onMouseLeave = () => {
    if (mouseLeaveDelayMS > 0) {
      clearTimeout(mouseEnterTimer);
      mouseOutTimer = setTimeout(() => {
        setIsHovering(false);
        isHoveringRef.current = false;
      }, mouseLeaveDelayMS);
    } else {
      setIsHovering(false);
    }
  };

  return [
    isHovering,
    {
      onMouseEnter,
      onMouseLeave,
    },
  ];
}
